function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useAuthorisedEntities, useSelectedLp } from "@amzn/carrierlogistics-commons/dist/hooks/authorisation";
import { isEmpty } from "lodash";
import useTermReportsConfig from "./useTermReportsConfig";
import { REPORTS_SHARING_PATH_PREFIX } from "../constants/routes";
import { AUTHORIZATION, AUTHORIZED_LP_FOR_SP_PERFORMANCE, AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA } from "../constants/authorization";
import isSiteExternal from "../utils/isSiteExternal";
import { useAuthorizedLogisticParties } from "@amzn/LogisticPartyHelperLib/dist";
import { SP_PERFORMANCE_MANAGEMENT } from "../constants";
import { CARRIER_LOGISTICS_URL_PREFIXES } from "../config/env/endpointConfig";
var getSideMenuNavItems = function(termReportConfigList) {
    return termReportConfigList.map(function(termReportConfig) {
        // In case of report sharing, if user is not authorized for term
        // Below isAuthorized true for children report types is to handle the case when user has access to the term
        // Else if term's isAuthorized is false then all children is automatically disabled by UI component
        var children = termReportConfig === null || termReportConfig === void 0 ? void 0 : termReportConfig.reportConfigList.map(function(reportConfig) {
            var _reportConfig_isExternalAllowed;
            return {
                link: "".concat(REPORTS_SHARING_PATH_PREFIX, "/").concat(termReportConfig.termUrlPath, "/").concat(reportConfig.reportTypeUrlPath),
                label: reportConfig.reportTypeDisplayName,
                children: false,
                isAuthorized: true,
                isExternalAllowed: (_reportConfig_isExternalAllowed = reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.isExternalAllowed) !== null && _reportConfig_isExternalAllowed !== void 0 ? _reportConfig_isExternalAllowed : true
            };
        });
        return {
            label: termReportConfig.termDisplayName,
            link: "".concat(REPORTS_SHARING_PATH_PREFIX, "/").concat(termReportConfig.termUrlPath),
            pamPermKey: termReportConfig.term,
            children: true,
            childNodes: children,
            hide: false
        };
    });
};
export var useSideNavMenuItems = function() {
    var termReportConfigs = useTermReportsConfig().termReportConfigs;
    var sideMenuNavItems = getSideMenuNavItems(termReportConfigs);
    if (isSiteExternal()) {
        var authorizedEntities = useAuthorisedEntities();
        var lpSelected = useSelectedLp();
        var entitiesWithPermissions = sideMenuNavItems.map(function(_param) {
            var config = _extends({}, _object_destructuring_empty(_param));
            var _authorizedEntities_config_pamPermKey, _authorizedEntities_lpSelected_lpId, _config_childNodes;
            if (isEmpty(lpSelected)) return _object_spread({
                isAuthorized: false
            }, config);
            var url = window.location.href;
            var authorisedLPForSPPerformance = url.includes(CARRIER_LOGISTICS_URL_PREFIXES.BETA_URL_PREFIX) ? AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA : AUTHORIZED_LP_FOR_SP_PERFORMANCE;
            // temp change for beta testing wil be replaced by AUTHORIZED_LP_FOR_SP_PERFORMANCE
            if (config.pamPermKey === SP_PERFORMANCE_MANAGEMENT && lpSelected.lpId !== authorisedLPForSPPerformance) return _object_spread({
                isAuthorized: false
            }, config);
            var isAuthorized = (authorizedEntities === null || authorizedEntities === void 0 ? void 0 : (_authorizedEntities_config_pamPermKey = authorizedEntities[config.pamPermKey]) === null || _authorizedEntities_config_pamPermKey === void 0 ? void 0 : _authorizedEntities_config_pamPermKey.length) && (authorizedEntities === null || authorizedEntities === void 0 ? void 0 : (_authorizedEntities_lpSelected_lpId = authorizedEntities[lpSelected.lpId]) === null || _authorizedEntities_lpSelected_lpId === void 0 ? void 0 : _authorizedEntities_lpSelected_lpId.includes(AUTHORIZATION.ACCESS));
            // Filter out report types which are not allowed for external flow
            return _object_spread_props(_object_spread({
                isAuthorized: isAuthorized
            }, config), {
                childNodes: config === null || config === void 0 ? void 0 : (_config_childNodes = config.childNodes) === null || _config_childNodes === void 0 ? void 0 : _config_childNodes.filter(function(cNode) {
                    return cNode.isExternalAllowed;
                })
            });
        });
        return {
            sideMenuNavItems: entitiesWithPermissions
        };
    }
    //TODO: temp change will be deprecated once we are able to give permission based on report type
    var authorizedLps = useAuthorizedLogisticParties(SP_PERFORMANCE_MANAGEMENT, true).authorizedLps;
    var desiredLP = authorizedLps === null || authorizedLps === void 0 ? void 0 : authorizedLps.find(function(lp) {
        return lp.logisticsPartyId === AUTHORIZED_LP_FOR_SP_PERFORMANCE;
    });
    var filteredSideNavItems = (sideMenuNavItems === null || sideMenuNavItems === void 0 ? void 0 : sideMenuNavItems.filter(function(sideNavItem) {
        return sideNavItem.pamPermKey !== SP_PERFORMANCE_MANAGEMENT;
    })) || [
        {}
    ];
    if (!isEmpty(authorizedLps) && !desiredLP && !isEmpty(filteredSideNavItems)) {
        return {
            sideMenuNavItems: filteredSideNavItems
        };
    }
    return {
        sideMenuNavItems: sideMenuNavItems
    };
};
export default useSideNavMenuItems;

//# sourceMappingURL=useSideNavMenuItems.js.map